import React from 'react';
import { observer } from 'mobx-react';
import { Heading } from 'components';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { Header } from 'libs/rendering/components/header';
import { ChangePortalBanner } from 'apps/client/components/ChangePortalBanner';
import { routerStore } from 'core/routing';
import DocumentHead from 'legacyComponents/documentHead';
import { QuoteList } from '../QuoteList';

export const QuoteListPage = observer(() => {
  let changePortalBanner = null;
  if (routerStore.route.name !== 'workspace') {
    changePortalBanner = <ChangePortalBanner />;
  }
  const title = 'My Quotes';
  return (
    <>
      <Header />
      <DocumentHead title={title} />
      <MainWrapper marginTop='2rem'>
        <Heading level={2} size='large'>
          My Quotes
        </Heading>
        {changePortalBanner}
        <QuoteList />
      </MainWrapper>
    </>
  );
});
